import React from 'react';

const Benefits = () => (
	<div className="container main">
		<h2>Benefits</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>What are the benefits of using the OECD <em>GlobalRecalls</em> Portal?</h4>
				<p>
					For <strong>government authorities</strong>, the Portal brings many benefits by enhancing information sharing about product recalls globally in a centralised and timely manner.
					Authorities can track emerging trends, particularly via the <a href="https://globalrecalls.oecd.org/#/dashboard">interactive dashboards</a>, and identify risks to consumers in their own jurisdiction that may require action.
					Global manufacturing supply chains and increased online shopping from overseas traders means that a product may require a recall in multiple jurisdictions if there is a safety issue.
				</p>
				<p>
					The Portal uses a common product taxonomy and is easy to integrate with authorities’ own national recall databases.
					An <a href="https://globalrecalls.oecd.org/#/admin">export API</a> is also available for governments, as well any member of the public, who may wish to examine the data on the Portal in detail.
				</p>
				<p>
					For <strong>businesses</strong>, notably for product <strong>manufacturers</strong>, the Portal provides information that could enable them to move more swiftly to address a safety problem, thereby reducing the number of incidents causing injury, and the costs associated with them.
					<strong>Businesses that import consumer products from overseas may also benefit by checking the recall status of products in other jurisdictions.</strong>
					<strong>Retailers and online marketplaces</strong> could also take swifter actions to remove unsafe products from sale by referring to the Portal.
				</p>
				<p>For <strong>consumers</strong> keen to compare products the Portal, which has a website version for mobile, also provides an easy way to check the recall status of a product on the go.</p>
			</div>
		</div>
	</div>
);

export default Benefits;



// WEBPACK FOOTER //
// ./src/views/static/en/benefits.js